import React from 'react';
import cn from 'classnames';

import { Statistic as AntStatistic, StatisticProps } from 'antd';

import styles from './Statistic.module.scss';
import { Countdown } from './Countdown';

export interface IStatisticProps extends StatisticProps {
  size?: 'large' | 'default' | 'small';
}

type TStatistic = React.FC<IStatisticProps> & {
  Countdown: typeof Countdown;
};

export const Statistic: TStatistic = (props) => {
  const { size = 'default', className } = props;
  return (
    <AntStatistic
      className={cn(
        styles.Statistic,
        {
          [styles[size]]: size,
        },
        className
      )}
      {...props}
    />
  );
};

Statistic.Countdown = Countdown;
